import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FulfilledOrders from './components/FulfilledOrders';

const fulfilledOrders = (props,{ t }) => (
  <Container>
    <FulfilledOrders {...props} />
  </Container>
);

fulfilledOrders.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(fulfilledOrders);
